var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQRcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "126.8%",
    height: "126.8%",
    x: "-13.4%",
    y: "-9.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.25,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.11372549 0 0 0 0 0.145098039 0 0 0 0 0.176470588 0 0 0 0.06 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__b",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0 0.216L16.678 0.216 16.678 0.856 0 0.856z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#DDE5ED",
    strokeWidth: 0.5,
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.4H20V19.599999999999998H0z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4) translate(1.667 2.4) translate(.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.387,
    height: 5.12,
    x: 0.64,
    y: 0.64,
    fill: "#FFF",
    stroke: "#506D85",
    strokeWidth: 1.28,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.6,
    x: 2.5,
    y: 2.4,
    fill: "#506D85",
    rx: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4) translate(1.667 2.4) translate(.833 8.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.387,
    height: 5.12,
    x: 0.64,
    y: 0.64,
    fill: "#FFF",
    stroke: "#506D85",
    strokeWidth: 1.28,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.6,
    x: 2.5,
    y: 2.4,
    fill: "#506D85",
    rx: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4) translate(1.667 2.4) translate(10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.387,
    height: 5.12,
    x: 0.64,
    y: 0.64,
    fill: "#FFF",
    stroke: "#506D85",
    strokeWidth: 1.28,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.6,
    x: 2.5,
    y: 2.4,
    fill: "#506D85",
    rx: 0.16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#506D85",
    d: "M15.502 11.518L15.502 13.44 14.157 13.444 14.168 14.725 16.836 14.722 16.836 11.517zM10.17 14.723L11.503 14.723 11.503 13.443 10.17 13.443zM10.167 10.878L11.501 10.878 11.501 9.598 10.167 9.598zM11.502 12.799L13.502 12.799 13.502 10.879 11.502 10.879zM15.5 10.878L14.167 10.879 14.167 8.96 15.5 8.96 15.501 9.698z",
    transform: "translate(4 4) translate(1.667 2.4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4) translate(1.667 2.4) translate(0 7.045)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRcode);
export default __webpack_public_path__ + "static/media/q-rcode.78e6be0b30dd1c83b3e17b82f65cc71e.svg";
export { ForwardRef as ReactComponent };